import(/* webpackMode: "eager" */ "/usr/src/app/front/apps/web/app/loading.tsx");
